import { render, staticRenderFns } from "./AppCarouselBlock.vue?vue&type=template&id=2d402b9f&scoped=true"
import script from "./AppCarouselBlock.vue?vue&type=script&lang=js"
export * from "./AppCarouselBlock.vue?vue&type=script&lang=js"
import style0 from "./AppCarouselBlock.vue?vue&type=style&index=0&id=2d402b9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d402b9f",
  null
  
)

export default component.exports